import SafeImage from './SafeImage';
import { FEATURED_PROJECTS, IMAGE_FALLBACK_CHAIN } from '../config/siteImages';

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden>
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

export default function Projects({ section }) {
  const eyebrow = section?.eyebrow || 'Selected work';
  const title = section?.title || 'Featured projects';
  const subtitle =
    section?.subtitle ||
    'Structural frames, architectural steel, and precision-fabricated details — delivered with the same rigour whether the job is large or bespoke.';

  const items =
    section?.items?.length > 0
      ? section.items.map((p) => ({
          name: p.name,
          cat: p.category || p.cat,
          image: p.imageUrl || p.image,
          ariaLabel: p.ariaLabel,
        }))
      : FEATURED_PROJECTS.map((p) => ({
          name: p.name,
          cat: p.cat,
          image: p.image,
          ariaLabel: `${p.name}, ${p.cat}. Open quote request.`,
        }));

  return (
    <section className="projects" id="projects">
      <div className="container">
        <div className="projects-header">
          <div>
            <div className="eyebrow">{eyebrow}</div>
            <h2 className="section-title">{title}</h2>
          </div>
          <p className="section-sub" style={{ marginBottom: 0 }}>
            {subtitle}
          </p>
        </div>

        {/*
          Project photos: FEATURED_PROJECTS in src/config/siteImages.js.
          Cards link to #contact until detail pages exist.
        */}
        <div className="projects-grid">
          {items.map((p) => (
            <a
              key={p.name}
              href="#contact"
              className="proj-card"
              aria-label={p.ariaLabel || `${p.name}, ${p.cat}. Open quote request.`}
            >
              <SafeImage
                src={p.image}
                fallbackSrcs={IMAGE_FALLBACK_CHAIN}
                alt=""
                wrapperClassName="proj-img-wrap"
                imgClassName="proj-img"
              />
              <div className="proj-overlay" aria-hidden />
              <div className="proj-info">
                <span className="proj-cat">{p.cat}</span>
                <h3 className="proj-name">{p.name}</h3>
                <span className="proj-link">
                  View project <ArrowIcon />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
